import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {ToastContext} from "../App";

export default function AssignProgram() {
    const [members, setMembers] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [renewInterval, setRenewInterval] = useState(0);
    const [currentPrograms, setCurrentPrograms] = useState({}); // updated: support multiple types

    const showToast = useContext(ToastContext);

    // جلب الأعضاء والبرامج عند تحميل الصفحة
    useEffect(() => {
        fetchMembers();
        fetchPrograms();
    }, []);

    // جلب البرنامج الحالي عند اختيار عضو
    useEffect(() => {
        if (selectedMember) fetchCurrentPrograms(selectedMember.id);
    }, [selectedMember]);

    const fetchMembers = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/members`);
            setMembers(res.data);
        } catch (err) {
            console.error(err);

        }
    };

    const fetchPrograms = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/programs`);
            setPrograms(res.data);
        } catch (err) {
            console.error(err);
            showToast("خطأ في جلب البرامج", "danger");
        }
    };

    const fetchCurrentPrograms = async (memberId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/member-programs/current/${memberId}`);
            setCurrentPrograms(res.data || {}); // { "تمارين": {...}, "غذاء": {...} }
        } catch (err) {
            console.error(err);
            showToast("خطأ في جلب البرامج الحالية", "danger");
        }
    };

    // تعيين أو إعادة تعيين البرنامج
    const assignProgram = async () => {
        if (!selectedMember || !selectedProgram) {
            showToast("يرجى تحديد عضو وبرنامج", "warning");
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/member-programs/assign`, {
                member_id: selectedMember.id,
                program_id: selectedProgram.id,
                type: selectedProgram.type,
                start_date: startDate || new Date(),
                repeat_days: 6,
                renew_interval_days: renewInterval || 0
            });
            showToast("تم تعيين البرنامج", "success");
            fetchCurrentPrograms(selectedMember.id);
        } catch (err) {
            console.error(err);
            showToast("خطأ في تعيين البرنامج", "danger");
        }
    };

    // حذف البرنامج الحالي
    const deleteProgram = async (programId) => {
        if (!window.confirm("هل تريد حذف البرنامج الحالي لهذا العضو؟")) return;
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/member-programs/${programId}`);
            showToast("تم حذف البرنامج الحالي", "success");
            fetchCurrentPrograms(selectedMember.id);
        } catch (err) {
            console.error(err);
            showToast("خطاء في حذف البرنامج الحالي", "danger");
        }
    };

    return (
        <div className={"content"}>

            <div className="container" dir="rtl">
                <h2 className="my-3 mt-5">تعيين برنامج للعضو</h2>

                {/* اختيار العضو */}
                <div className="mb-3">
                    <label className="form-label">اختر العضو:</label>
                    <select className="form-select" onChange={e => {
                        const member = members.find(m => m.id === parseInt(e.target.value));
                        setSelectedMember(member);
                    }}>
                        <option value="">-- اختر العضو --</option>
                        {members.map(m => (
                            <option key={m.id} value={m.id}>{m.full_name}</option>
                        ))}
                    </select>
                </div>

                {/* اختيار البرنامج */}
                <div className="mb-3">
                    <label className="form-label">اختر البرنامج:</label>
                    <select className="form-select" onChange={e => {
                        const program = programs.find(p => p.id === parseInt(e.target.value));
                        setSelectedProgram(program);
                    }}>
                        <option value="">-- اختر البرنامج --</option>
                        {programs.map(p => (
                            <option key={p.id} value={p.id}>{p.name} ({p.type})</option>
                        ))}
                    </select>
                </div>

                {/* تاريخ بدء البرنامج */}
                <div className="mb-3">
                    <label className="form-label">تاريخ بدء البرنامج:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                    />
                </div>

                {/* فترة التجديد */}
                <div className="mb-3">
                    <label className="form-label">مدة التجديد (عدد أيام):</label>
                    <input
                        type="number"
                        className="form-control"
                        value={renewInterval}
                        onChange={e => setRenewInterval(e.target.value)}
                    />
                </div>

                {/* عرض البرامج الحالية لكل نوع */}
                {Object.keys(currentPrograms).length > 0 && (
                    <div className="mb-3">
                        {Object.keys(currentPrograms).map(type => (
                            <div key={type} className="mb-3 p-3 border rounded bg-light">
                                <h5>البرنامج الحالي للعضو ({type}): {currentPrograms[type].program_name}</h5>
                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => deleteProgram(currentPrograms[type].id)}
                                >
                                    حذف البرنامج الحالي
                                </button>
                            </div>
                        ))}
                    </div>
                )}

                {/* زر التعيين */}
                <button className="btn btn-primary" onClick={assignProgram}>تعيين / إعادة تعيين البرنامج</button>
            </div>
        </div>
    );
}
